import { createContext, useMemo } from 'react'

export type TableCustomizerContextType = Props

export const TableCustomizerContext =
  createContext<TableCustomizerContextType | null>(null)

interface Props {
  onAddNewRow: () => void
  onCellEdit: (path: string, value: string) => void
}

export const TableCustomizerProvider = ({
  children,
  onAddNewRow,
  onCellEdit,
}: React.PropsWithChildren<Props>) => {
  const value = useMemo(
    () => ({
      onAddNewRow,
      onCellEdit,
    }),
    [onAddNewRow, onCellEdit],
  )

  return (
    <TableCustomizerContext.Provider value={value}>
      {children}
    </TableCustomizerContext.Provider>
  )
}
